import { TasklistService } from '@/api/tasklist'
import { DownloadButton } from '@/components/ui/Button'
import { CustomComponentContext } from '@/utils/contexts/CustomComponentContext'
import { useContext } from 'react'

export default function MeninjauKPIBulananSoftSkill() {
  const { fieldSpec, taskData } = useContext(CustomComponentContext)

  const variables = taskData.variables || {}
  const instanceHistories = taskData.instance_history || []
  const { mutate, isLoading } = TasklistService.useDownloadFile()

  const handleClick = (urlDownload: string) => {
    mutate({
      urlDownload: urlDownload,
      name: `Laporan KPI Bulanan - ${variables?.periodeBulan} - ${instanceHistories?.[0]?.user_fullname}`,
    })
  }

  return (
    <div className="border-2 border-[#c4c4c480] rounded-xl">
      <div className="flex flex-col p-4">
        <label className="text-lg sm:text-xl font-semibold mb-4" htmlFor={fieldSpec?.name}>
          Proses Pemantauan KPI Bulanan & Mingguan
        </label>
        <div className="overflow-x-auto">
          <table className="table-auto w-full mx-auto" role="presentation">
            <tr>
              <td>Periode Bulan</td>
              <td>{variables.periodeBulan}</td>
            </tr>
            <tr>
              <td>Download Laporan KPI Bulanan</td>
              <td className="pr-2 text-sm sm:text-md">
                <DownloadButton
                  className="h-fit"
                  onClick={() => handleClick(variables?.fileKpiPenilaianKpiBulananManager)}
                  type="button"
                  size="small"
                  loading={isLoading}
                >
                  Download Laporan KPI Bulanan
                </DownloadButton>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  )
}
